module.exports = __webpack_public_path__ + "static/media/in-collection-search-guide.8e754449.png";